import moment from 'moment-timezone'

export function getUpdatedTime (date, ts, timeZone) {
  if ((ts && date) && (ts.isValid() && date.isValid())) {
    const dateTime = moment.tz(date, timeZone).set({ hour: ts.hour(), minute: ts.minutes(), second: 0, millisecond: 0 })
    return dateTime.format()
  } else {
    return undefined
  }
}